import type { RegistrationProgressResponse } from './status-display';

export function formatRegistrationSubmittedAt(
  value: RegistrationProgressResponse['registration_submitted_at']
): string | null {
  if (value == null) {
    return null;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const formattedDate = new Intl.DateTimeFormat('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);

  const formattedTime = new Intl.DateTimeFormat('id-ID', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZoneName: 'shortOffset',
  })
    .format(date)
    .replace('GMT+7', 'WIB')
    .replace('GMT+8', 'WITA')
    .replace('GMT+9', 'WIT');

  return `Diajukan: ${formattedDate} • ${formattedTime}`;
}
